import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "41",
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M35 35.6592H10.3333C8.46649 35.6592 7.53307 35.6592 6.82003 35.2959C6.19282 34.9763 5.68289 34.4664 5.36331 33.8391C5 33.1261 5 32.1927 5 30.3258V5.65918M11.6667 18.1592V29.8258M19.1667 9.82585V29.8258M26.6667 18.1592V29.8258M34.1667 9.82585V29.8258",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }